export default "__VITE_ASSET__DR4ypKr7__"